import { render, staticRenderFns } from "./BoxTracking.vue?vue&type=template&id=44f92046&"
import script from "./BoxTracking.vue?vue&type=script&lang=js&"
export * from "./BoxTracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports